import { DynamicConfigs, useDynamicConfigs } from '@hungryroot/dynamic-configs';
import { getUserAgentMatch } from '../utils/getUserAgentMatch';

export const useThirdPartySSODisabledUserAgentMatch = () => {
  const { data } = useDynamicConfigs({
    name: [DynamicConfigs.FunnelThirdPartySSODisabledUserAgents],
  });

  if (!data || !data.results || !data.results.length) {
    return false;
  }

  return getUserAgentMatch(data?.results[0]?.value);
};
